import { createTheme } from '@mui/material/styles';

const CHART_SERIES_PALETTE = [
  '#ff9900', '#2d3748', '#48bb78', '#8B5CF6',
  '#EC4899', '#06B6D4', '#ed8936', '#6366F1',
];

const theme = createTheme({
  palette: {
    primary:    { main: '#ff9900', dark: '#cc7a00', light: '#fff3e0' },
    secondary:  { main: '#2d3748', dark: '#1a202c', light: '#4a5568' },
    warning:    { main: '#ed8936' },
    error:      { main: '#EF4444' },
    success:    { main: '#22C55E' },
    info:       { main: '#3B82F6' },
    background: { default: '#F8FAFC', paper: '#FFFFFF' },
    text:       { primary: '#0F172A', secondary: '#64748B', disabled: '#94A3B8' },
    divider:    '#E2E8F0',
    surface:    { elevated: '#F1F5F9' },
    chart:      CHART_SERIES_PALETTE,
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    h1:      { fontSize: 24, fontWeight: 700 },
    h2:      { fontSize: 18, fontWeight: 600 },
    h3:      { fontSize: 14, fontWeight: 600 },
    body1:   { fontSize: 14, fontWeight: 400 },
    caption: { fontSize: 12, fontWeight: 500 },
    metric:  { fontSize: 28, fontWeight: 700 },
  },
  shape: { borderRadius: 10 },
  shadows: [
    'none',
    '0 1px 2px 0 rgba(0,0,0,0.05)',                              // sm
    '0 4px 6px -1px rgba(0,0,0,0.07), 0 2px 4px -2px rgba(0,0,0,0.05)', // md
    '0 10px 15px -3px rgba(0,0,0,0.08), 0 4px 6px -4px rgba(0,0,0,0.05)', // lg
    ...Array(21).fill('none'),
  ],
});

export { CHART_SERIES_PALETTE };
export default theme;
